import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import moment from 'moment';
import * as Sentry from "@sentry/react";
import * as SentryBrowser from "@sentry/browser";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";
import common_en from "./translations/en/common.json";
import "rsuite/dist/rsuite.min.css";

i18next.init({
  interpolation: { escapeValue: false },  // React already does escaping
  lng: 'en',  
  fallbackLng: 'en',                            // language to use
  resources: {
    en: {
        common: common_en               // 'common' is our custom namespace
    }
  }
});

moment.updateLocale('en', {
  relativeTime: {
    future: "in %s",
    past: "%s ago",
    s: 'a few sec',
    ss: '%d sec',
    m: "a min",
    mm: "%d min",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_GLOBAL_ENVIRONMENT || "development",
  integrations: [
    new Sentry.BrowserTracing({
      tracingOrigins: ["localhost", /^\//],
      beforeNavigate: (context) => {
        // Custom beforeNavigate logic if needed
        return context;
      },
    }),
    new Sentry.Replay(),
    // SentryBrowser.httpClientIntegration(),
    SentryBrowser.browserApiErrorsIntegration(),
  ],
  tracesSampleRate: 1.0, // Adjust in production
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'poppins',
      textTransform: 'none',
      color: "#000",
    },
  },
  breakpoints: {
    values: {
      xxs: 0, // small phone
      xs: 300, // phone
      sm: 600, // tablets
      md: 900, // small laptop
      lg: 1200, // desktop
      xl: 1536 // large screens
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18next}>
        <CssBaseline />
        <App />
      </I18nextProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
